var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Button, Pill } from "../../../../Components/UI";
import { StarIcon } from '@heroicons/react/20/solid';
import { Translate, I18NLinkV2 as I18NLink } from "../../../../../I18N";
import { Tooltip } from 'flowbite-react';


const columnHelper = createColumnHelper();

const NameCell = ({ cell }) => /*#__PURE__*/
_jsx("div", { className: "flex items-center gap-2" }, void 0,
cell.row.original.synced ? /*#__PURE__*/
_jsx("span", { className: "text-primary-700 cursor-not-allowed" }, void 0, cell.getValue()) : /*#__PURE__*/

_jsx(I18NLink, {
  to: `/settings/templates/edit/${cell.row.original._id}`,
  className: "text-primary-700 hover:underline cursor-pointer" }, void 0,

cell.getValue()
),

cell.row.original.default && /*#__PURE__*/
_jsx(Pill, { color: "blue" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Default")
)

);


const TranslationCell = ({ cell }) => /*#__PURE__*/
_jsx(Translate, { context: cell.row.original._id }, void 0, cell.getValue());


function formatNumberShort(value) {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(value % 1_000_000 === 0 ? 0 : 1)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(value % 1_000 === 0 ? 0 : 1)}k`;
  }
  return value.toString();
}

const EntityCountCell = ({ cell }) => /*#__PURE__*/
_jsx("span", {}, void 0, formatNumberShort(cell.getValue()));


const DefaultButton =
(handleSetDefault) =>
({ cell }) => /*#__PURE__*/
_jsx(Button, {
  styling: cell.row.original.default ? 'solid' : 'light',
  onClick: () => handleSetDefault(cell.row.original),
  className: "leading-4 m-auto",
  disabled: cell.row.original.default || cell.row.original.synced }, void 0, /*#__PURE__*/

_jsx(Translate, { className: "sr-only" }, void 0, "Set as default"), /*#__PURE__*/
_jsx(StarIcon, {
  className:
  cell.row.original.default ?
  'w-4 text-white' :
  'w-4 text-white stroke-current stroke-gray-300 stroke-2' }

)
);


const EditButton = ({ cell }) => /*#__PURE__*/
_jsx(I18NLink, { to: `/settings/templates/edit/${cell.row.original._id}`, className: "px-3 py-1" }, void 0, /*#__PURE__*/
_jsx(Button, { styling: "light", disabled: cell.row.original.synced, className: "leading-4" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Edit")
)
);


const NameHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Name");
const TranslationHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Translation");
const EntityCountHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Entities");
const DefaultHeader = () => /*#__PURE__*/_jsx(Translate, { className: "keep-all" }, void 0, "Set as default");
const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Action");

const SyncedTemplateCell = ({ cell }) =>
cell.getValue() ? /*#__PURE__*/
_jsx(Tooltip, {
  content: /*#__PURE__*/
  _jsx("div", { className: "text-xs text-gray-600" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "The source of this template is a sync."), /*#__PURE__*/
  _jsx("br", {}), /*#__PURE__*/
  _jsx(Translate, {}, void 0, "All editing options will be disabled.")
  )

  // eslint-disable-next-line react/style-prop-object
  , style: "light" }, void 0, /*#__PURE__*/

_jsx("span", { className: "cursor-help" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Synced template")
)
) :
null;
const SyncedTemplateHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Synced Template");

const columns = (
handleSetDefault,
hasSyncedTemplates = false) =>
{
  const cols = [
  columnHelper.accessor('name', {
    id: 'name',
    header: NameHeader,
    cell: NameCell,
    enableSorting: true
  }),
  columnHelper.accessor('translation', {
    id: 'translation',
    header: TranslationHeader,
    cell: TranslationCell,
    enableSorting: true
  })];


  if (hasSyncedTemplates) {
    cols.push(
      columnHelper.accessor('synced', {
        id: 'synced',
        header: SyncedTemplateHeader,
        cell: SyncedTemplateCell,
        meta: { headerClassName: 'w-2/12 text-center' }
      })
    );
  }

  cols.push(
    columnHelper.accessor('entityCount', {
      id: 'entityCount',
      header: EntityCountHeader,
      cell: EntityCountCell,
      enableSorting: true,
      meta: { headerClassName: 'w-09ext-center' }
    }),
    columnHelper.accessor('default', {
      id: 'default',
      header: DefaultHeader,
      cell: DefaultButton(handleSetDefault),
      enableSorting: false,
      meta: { headerClassName: 'w-2/12 text-center', contentClassName: 'text-center' }
    }),
    columnHelper.accessor('_id', {
      id: 'actions',
      header: ActionHeader,
      cell: EditButton,
      enableSorting: false,
      meta: { headerClassName: 'w-0 text-center', contentClassName: 'text-center' }
    })
  );
  return cols;
};

export {
  NameCell,
  TranslationCell,
  DefaultButton,
  EditButton,
  NameHeader,
  TranslationHeader,
  DefaultHeader,
  ActionHeader,
  EntityCountCell,
  EntityCountHeader,
  SyncedTemplateCell,
  SyncedTemplateHeader,
  columns };